import React from 'react';

import OwnersManagementForm from './OwnersManagementForm';

export * from './constants';

export const OwnersManagement = ({ ...props }) => {
  return <OwnersManagementForm {...props} title={'Manage Campaign Owners'} />;
};
